import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Invalidate speed event
 *
 * @private
 */
export const invalidateSpeedEvent = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.client.gps.wwgps.EventInfo,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/eventInfo/invalidate', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/eventInfo/invalidate', {
      category: 'rpc',
      type: 'rpc/eventInfo/invalidate',
      event: payload,
    })
    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {invalidateSpeedEvent}`,
      { tags: ['rpc', 'eventInfo'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Invalidate speed event failed`,
      error,
    })
  }
})
